"use client";

import React, { useSyncExternalStore } from "react";
import { QRCodeSVG } from "qrcode.react";
import { appDownloadService } from "@/src/shared/features/app-download/services";

const subscribeNever = () => () => {};

/** A QR code a phone camera opens as this site's `/app` page, which hands it to the app. */
const AppQrCode: React.FC<{ className?: string }> = ({ className = "" }) => {
  const origin = useSyncExternalStore(
    subscribeNever,
    () => window.location.origin,
    () => null,
  );

  return (
    <figure
      className={`flex w-[212px] flex-col items-center rounded-2xl border border-[#EBEBEB] bg-white p-4 ${className}`}
    >
      <div className="flex h-[180px] w-[180px] items-center justify-center rounded-xl border-4 border-brand-dark p-2">
        {origin ? (
          <QRCodeSVG
            value={appDownloadService.qrTarget(origin)}
            size={156}
            fgColor="#222222"
            level="M"
            title="Scan to open the Travela app"
          />
        ) : (
          <div className="h-[156px] w-[156px] animate-pulse rounded bg-[#F7F7F7]" />
        )}
      </div>
      <figcaption className="mt-3 text-center text-13 leading-4 text-ink-secondary">
        Scan with your phone&apos;s camera to open the app
      </figcaption>
    </figure>
  );
};

export default AppQrCode;
